import { render, staticRenderFns } from "./WordSlider.vue?vue&type=template&id=609c98e8&scoped=true"
var script = {}
import style0 from "./WordSlider.vue?vue&type=style&index=0&id=609c98e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c98e8",
  null
  
)

export default component.exports